import { Component, Inject, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../shared/material/material.module';
import { ExportService, ExportFormat, ExportOptions } from '../services/export.service';

export interface ExportDialogData {
  searchCriteria: any;
  results: any[];
  searchType: 'service' | 'resource';
}

@Component({
  selector: 'app-export-dialog',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss']
})
export class ExportDialogComponent {
  selectedFormat = signal<ExportFormat>('pdf');
  
  // Computed signal para o progresso de exportação
  exportProgress = computed(() => this.exportService.progress());
  
  isExporting = computed(() => this.exportProgress().isExporting);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ExportDialogData,
    private dialogRef: MatDialogRef<ExportDialogComponent>,
    private exportService: ExportService
  ) {}

  selectFormat(format: ExportFormat): void {
    if (!this.isExporting()) {
      this.selectedFormat.set(format);
    }
  }

  async export(): Promise<void> {
    const options: ExportOptions = {
      format: this.selectedFormat(),
      searchCriteria: this.data.searchCriteria,
      results: this.data.results,
      searchType: this.data.searchType
    };

    try {
      await this.exportService.exportResults(options);
      
      // Aguarda um pouco para mostrar a mensagem de sucesso
      setTimeout(() => {
        this.dialogRef.close(true);
      }, 1000);
    } catch (error) {
      console.error('Erro ao exportar:', error);
      // Mantém o diálogo aberto em caso de erro
    }
  }

  cancel(): void {
    if (!this.isExporting()) {
      this.dialogRef.close(false);
    }
  }

  getFormatIcon(format: ExportFormat): string {
    switch (format) {
      case 'pdf':
        return 'picture_as_pdf';
      case 'excel':
        return 'table_chart';
      case 'csv':
        return 'description';
      default:
        return 'file_download';
    }
  }

  getFormatDescription(format: ExportFormat): string {
    switch (format) {
      case 'pdf':
        return 'Documento formatado com tabelas e critérios de busca';
      case 'excel':
        return 'Planilha Excel com múltiplas abas (critérios e resultados)';
      case 'csv':
        return 'Arquivo CSV simples para importação em outras ferramentas';
      default:
        return '';
    }
  }
}
